import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=b3dd2680&"
import script from "./Id.vue?vue&type=script&lang=ts&"
export * from "./Id.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports